module.exports = __webpack_public_path__ + "static/media/PRISM flyer - Roebling.64744439.sketch";